import { environment } from "@/lib/resources";
import $ from "jquery";

if (environment.inocon) {
	$(".priority-table__menu input")
		.on("change", onChanged)
		.trigger("change");

	function onChanged(e: JQuery.ChangeEvent) {
		$("table.priority-table")
			.find(`#${e.currentTarget.value}, td[headers="${e.currentTarget.value}"]`)
			.toggleClass("column-hidden-mobile", !e.currentTarget.checked);
	}
}
